(() => {
  let timeout;
  let refreshInFlight = false;

  const updateCounters = (itemCount) => {
    document.querySelectorAll('.cart-count, [data-cart-count]').forEach((counter) => {
      counter.textContent = itemCount;
      counter.hidden = itemCount < 1;
      counter.classList.remove('cart-count--bump', 'cart-bubble--animating');
      void counter.offsetWidth;
      counter.classList.add('cart-count--bump', 'cart-bubble--animating');
    });
  };

  const showFeedback = (cart) => {
    let toast = document.querySelector('.ym-cart-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'ym-cart-toast';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      document.body.appendChild(toast);
    }
    const mark = document.createElement('span');
    mark.className = 'ym-cart-toast__mark';
    mark.setAttribute('aria-hidden', 'true');
    mark.textContent = '✓';
    const message = document.createElement('span');
    message.textContent = `Ürün sepetinize eklendi.`;
    toast.replaceChildren(mark, message);
    toast.classList.add('is-visible');
    clearTimeout(timeout);
    timeout = setTimeout(() => toast.classList.remove('is-visible'), 4200);
  };

  const refreshCart = async () => {
    if (refreshInFlight) return;
    refreshInFlight = true;
    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin'
      });
      if (!response.ok) return;
      const cart = await response.json();
      const itemCount = Number(cart.item_count || 0);
      updateCounters(itemCount);
      document.dispatchEvent(new CustomEvent('ym:cart-feedback', { detail: { cart, itemCount } }));
      document.documentElement.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart } }));
      document.documentElement.dispatchEvent(new CustomEvent('cart:build', { bubbles: true, detail: { cart } }));
    } finally {
      refreshInFlight = false;
    }
  };

  document.documentElement.addEventListener('cart:updated', (event) => {
    const cart = event.detail?.cart || {};
    const itemCount = Number(cart.item_count ?? 0);
    if (itemCount > 0) {
      updateCounters(itemCount);
      showFeedback(cart);

      // cart-icon.js ThemeEvents.cartUpdate ('cart:update') dinliyor — tetikle
      document.dispatchEvent(
        new CustomEvent('cart:update', {
          bubbles: true,
          detail: { resource: cart, data: { itemCount } },
        })
      );

      // Doğrudan cart-icon element'ının setter'ını kullan (varsa)
      const cartIconEl = document.querySelector('cart-icon');
      if (cartIconEl && typeof cartIconEl.renderCartBubble === 'function') {
        cartIconEl.renderCartBubble(itemCount, false);
      }
    }
  });

  // Sepet linklerine tıklandığında sepet yerine direkt checkout'a yönlendir
  document.addEventListener('click', (e) => {
    const cartLink = e.target.closest('a[href="/cart"], a[href^="/cart?"]');
    if (cartLink) {
      e.preventDefault();
      window.location.href = '/checkout';
    }
  });
})();